<template>
  <img
    v-prevent-right-click="{ disabled: accountStore.loggedIn }"
    :src="displaySrc"
    :alt="alt"
    class="pointer-events-none"
  />
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { useAccountStore } from '@core/stores/account.store';

  export interface Props {
    src?: string | null;
    alt: string;
    text?: string;
    size?: number | string;
  }
  const accountStore = useAccountStore();
  const props = withDefaults(defineProps<Props>(), { src: undefined, size: 300, text: 'image' });
  const displaySrc = computed(() => {
    if (props.src) return props.src;
    return `https://placehold.co/${props.size}?text=${props.text}`;
  });
</script>
